module.exports = __webpack_public_path__ + "static/media/calvinist_parrot.8a31a379.gif";